import React, {useEffect, useState} from "react"

import {NoActivities} from "./NoActivities"
import {List} from "./List"

import {api} from "@indebted/api"
import {LoadingPage} from "@indebted/components/Loading"

function Activities({customerID}: {customerID: string}) {
	const [Component, setComponent] = useState(<LoadingPage />)

	useEffect(() => {
		api.customer
			.activities(customerID)
			.then((activities) => {
				if (activities.Activities.length === 0) {
					setComponent(<NoActivities>No activities</NoActivities>)
				} else {
					setComponent(<List activities={activities} customerID={customerID} />)
				}
			})
			.catch(() => {
				setComponent(<NoActivities>Something went wrong</NoActivities>)
			})
	}, [customerID])

	return Component
}

export {Activities}
